import { HttpService } from '../http.service'
import { getData } from '../get-table'

const http = new HttpService()

interface Users {
  id?: string
  email?: string
  name: string
  defaultRole: string
  allowedRoles: string[]
  allowedPayrolls: string[]
  enabled?: boolean
}

export async function getUsers(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = '',
  includeInactives: boolean = false
): Promise<any> {
  // order by
  let orderBy = {}
  dataOrder !== ''
    ? (orderBy = { by: dataOrder[1], sense: dataOrder[0] })
    : (orderBy = { by: 'name', sense: 'asc' })
  // result
  const query = {
    offset,
    limit: perPage,
    modifiers: {
      order: orderBy,
      where: { params: ['name', 'email'], like: search },
      includeInactives
    }
  }
  const response: any = await http.post('/auth/users/list/', query)
  return { query, data: response.data }
}

export async function getUser(id: string): Promise<any> {
  const response: any = await http.get(`/auth/users/${id}`)
  return response.data
}

export async function getPayrolls(): Promise<any> {
  const response: any = await getData({
    tables: ['pg_payrolls'],
    fields: [
      'id',
      "CONCAT(code,' - ', name) as name",
      'code',
      'updated_at',
      'is_inactive'
    ],
    where: ['is_inactive = false'],
    modifier: ['order by code asc']
  })
  return response[0]
}

export async function createUser(data: Users): Promise<boolean> {
  const response: any = await http.post('/auth/users/', {
    email: data.email,
    name: data.name,
    defaultRole: data.defaultRole,
    allowedRoles: data.allowedRoles,
    allowedPayrolls: data.allowedPayrolls
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateUser(id: string, data: Users): Promise<boolean> {
  const response: any = await http.put(`/auth/users/${id}`, {
    name: data.name,
    defaultRole: data.defaultRole,
    allowedRoles: data.allowedRoles,
    allowedPayrolls: data.allowedPayrolls
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateStateUser(
  id: string,
  state: boolean
): Promise<boolean> {
  const response: any = await http.put(`/auth/users/${id}/enable/`, {
    enable: state
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function changePasswordUser(
  id: string,
  password: string
): Promise<boolean> {
  const response: any = await http.put(`/auth/users/${id}/update-password`, {
    password: password
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
